<template>
  <div class="order-list-cell" @click="gotoOrderDetail">
    <div class="order-list-cell-line c:row-between-center header">
      <div class="title">订单编号：{{ data.orderNo }}</div>
      <div class="copy" @click.stop="onCopy(data.orderNo)">
        <img src="@/assets/icons/copy.svg" alt="" />
      </div>
      <div class="status">{{ orderStatusString }}</div>
    </div>
    <div class="order-list-cell-line c:row-between-center infos">
      <div class="type">
        {{ data.type === 2 ? "订金单" : "远程销售单" }}
      </div>
      <div class="time">
        {{ (data.submitTime || data.createdDate) | formatDateTime }}
      </div>
      <div class="price">¥ {{ data.amount | filterPrice }}</div>
    </div>
    <div v-if="isItemsShown" class="items">
      <div class="pic-list c:row-start-center c:flex-nowrap">
        <div
          v-for="item in filteredItems"
          :key="item.id"
          class="pic c:row-center"
        >
          <img :src="item.productPicSmall || item.productPic" alt="" />
        </div>
      </div>
    </div>
    <div class="order-list-cell-line c:row-between-center footer">
      <div class="store">{{ data.storeName }}</div>
      <div class="sa">SA: {{ data.caName }}</div>
      <div class="customer c:row-end-center c:flex-nowrap">
        <div class="customer-avator">
          <img :src="data.customerAvatar" alt="" />
        </div>
        <div class="customer-name">
          {{ data.customerName || data.customerNickname }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getEnumMap } from "@/api";
import { copyText } from "@/utils/string";
import { ImagePreview } from "vant";

export default {
  props: { data: Object },
  data() {
    return { orderStatusMap: {} };
  },
  computed: {
    filteredItems() {
      return (this.data.orderItems || []).filter(
        (item) => item.productPicSmall || item.productPic
      );
    },
    isItemsShown() {
      // console.log(this.data.type, this.filteredItems.length);
      return this.data.type === 1 && this.filteredItems.length > 0;
    },
    orderStatusString() {
      return this.orderStatusMap[this.data.status] || "";
    },
  },
  mounted() {
    getEnumMap("OrderStatusEnum").then((map) => {
      this.orderStatusMap = map;
    });
  },
  methods: {
    preview(index) {
      ImagePreview(
        this.filteredItems.map(
          (item) => item.productPicSmall || item.productPic
        ),
        index
      );
    },
    onCopy(e) {
      copyText(e);
      this.$toast("复制成功");
    },
    gotoOrderDetail() {
      // console.log("gotoOrderDetail", this.data);
      this.$router.push({
        name: "Order",
        query: {
          orderNo: this.data.orderNo,
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.order-list-cell {
  width: 100%;
  height: auto;
  padding: 14/20rem 20/20rem;
  background-color: #fff;
  border-bottom: 3/20rem solid #e4e4e4;

  .order-list-cell-line {
    > :nth-child(3) {
      flex: 1;
      text-align: right;
    }
  }

  .header {
    width: 100%;
    height: 30/20rem;
    margin-bottom: 4/20rem;

    .title,
    .status {
      line-height: 20/20rem;
      font-size: 12/20rem;
      font-weight: 500;
      color: #000;
    }

    .copy {
      padding: 0 6/20rem;
      img {
        width: 14/20rem;
        height: 14/20rem;
      }
    }
  }
  .infos {
    width: 100%;
    height: 17/20rem;
    margin-bottom: 8/20rem;

    line-height: 17/20rem;
    font-size: 12/20rem;
    font-weight: 400;
    color: #7d7d7d;

    .time {
      padding-left: 14/20rem;
    }

    .price {
      color: #5e5e5e;
    }
  }
  .items {
    width: 100%;
    height: 94/20rem;
    margin-bottom: 8/20rem;

    overflow-x: auto;
    overflow-y: hidden;
    &::-webkit-scrollbar {
      display: none;
    }

    .pic-list {
      gap: 8/20rem;

      width: max-content;
      height: 94/20rem;

      .pic {
        aspect-ratio: 100 / 130;
        width: auto;
        height: 94/20rem;

        img {
          max-width: 100%;
          max-height: 100%;
          object-fit: contain;
        }
      }
    }
  }
  .footer {
    width: 100%;
    height: 19/20rem;

    line-height: 19/20rem;
    font-size: 12/20rem;
    font-weight: 400;
    color: #7d7d7d;

    .sa {
      padding-left: 14/20rem;
    }

    .customer {
      gap: 10/20rem;

      width: auto;
      height: 19/20rem;

      .customer-avator {
        width: 19/20rem;
        height: 19/20rem;
        border-radius: 50%;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
        }
      }
      .customer-name {
        line-height: 19/20rem;
        font-weight: 500;
        font-size: 12/20rem;
        letter-spacing: 0;
        color: #000000;
      }
    }
  }
}
</style>
